import uuidv4 from 'uuid/v4';
import './modal-factory.scss';
import _ from 'lodash';

export default angular
  .module('doxy.common.components.modalFactory', [])
  .factory('ModalFactory', function ($rootScope, $modal) {
    let currentModal = null;
    let currentModalId = null;

    const hideCurrentModal = () => {
      currentModal && currentModal.hide();
      currentModal = null;
      currentModalId = null;
    };

    /**
     * @param {Object|String} configOrTemplateUrl Modal config or modal content template url
     * @param {String} bg
     * @return {Promise<any>}
     */
    function showModal(configOrTemplateUrl = {}, bg = 'brand') {
      currentModalId = 'modal-' + uuidv4();
      const config = {
        animation: false,
        scope: $rootScope.$new(),
        backdrop: 'static',
        keyboard: false,
        prefixEvent: currentModalId,
        prefixClass: `${bg}-modal`,
      };

      if (_.isString(configOrTemplateUrl)) {
        config.contentTemplate = configOrTemplateUrl;
      } else {
        Object.assign(config, _.omit(configOrTemplateUrl, 'scope'));
        Object.assign(config.scope, configOrTemplateUrl.scope || {});
      }

      config.scope.$hide = hideCurrentModal;
      if (_.isObject(config.scope.$ctrl)) {
        config.scope.$ctrl.$hide = hideCurrentModal;
      }

      currentModal = $modal(config);

      return new Promise((resolve) =>
        $rootScope.$once(currentModalId + '.hide', resolve)
      );
    }

    // Brand color background modal
    function showBrandModal(props) {
      hideCurrentModal();
      return showModal(props, 'brand');
    }

    // Danger (red-ish) color background modal
    function showWarningModal(props) {
      hideCurrentModal();
      return showModal(props, 'warning');
    }

    function waitForCurrentModalToClose() {
      if (!currentModal) return Promise.resolve();
      return new Promise((resolve) =>
        $rootScope.$once(currentModalId + '.hide', resolve)
      );
    }

    return {
      showBrandModal,
      showWarningModal,
      hideCurrentModal,
      waitForCurrentModalToClose,
    };
  }).name;
